import { BrandEntity, BrandEntityId } from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const brandCreateSuccess = createAction(
  "[Brand] Create Success",
  props<{ brand: BrandEntity }>()
);

export const brandDeleteSuccess = createAction(
  "[Brand] Delete Success",
  props<{ brandId: BrandEntityId }>()
);

export const brandGetList = createAction("[Brand] Get List");
export const brandGetListSuccess = createAction(
  "[Brand] Get List Success",
  props<{ brands: BrandEntity[] }>()
);
export const brandGetListFailure = createAction(
  "[Brand] Get List Failure",
  props<{ error: string }>()
);

export const brandInUse = createAction(
  "[Brand] In Use",
  props<{ brandId: BrandEntityId }>()
);

export const brandUpdateSuccess = createAction(
  "[Brand] Update Success",
  props<{ brand: BrandEntity }>()
);
